import { ChangeDetectorRef, Component, ElementRef, Inject, OnDestroy, PLATFORM_ID, ViewChild } from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { GoogleMapsModule } from '@angular/google-maps';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { VideoImovelComponent } from '../video-imovel/video-imovel.component';
import { ImagensComponent } from '../imagens/imagens.component';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ImovelService } from '../../services/imovel.service';
import { buildWhatsAppUrl, groupBy, groupByImoveis } from './detalhes-imovel.util';
import { CaptadorImovelDto, ImovelResponseDto } from '../../dto/imovel-response.dto';
import { SplitPipe } from '../../pipes/split.pipe';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';
import { CreateLeadDto } from '../../dto/create-lead.dto';
import { UtilService } from '../../services/util.service';
import { LeadService } from '../../services/lead.service';
import { Subscription } from 'rxjs/internal/Subscription';
import { ModalService } from '../../services/modal.service';
import { ImagensFullscreenComponent } from '../imagens-fullscreen/imagens-fullscreen.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DeveExibirAtributoPipe } from '../../pipes/deve-exibir-atributo';
import { MatIconModule } from '@angular/material/icon';
import { CorretorService } from '../../services/corretor.service';
import { CorretorResposneDto } from '../../dto/corretor-response.dto';
import { ComodidadesComponent } from '../../components/comodidades/comodidades.component';
import { TagsComponent } from '../../components/tags/tags.component';
import { Title } from '@angular/platform-browser';

@Component({
   standalone: true,
   imports: [
      NgxMaskDirective,
      MatIconModule,
      CommonModule,
      GoogleMapsModule,
      MatDialogModule,
      ReactiveFormsModule,
      SplitPipe,
      DeveExibirAtributoPipe,
      ComodidadesComponent,
      TagsComponent
   ],
   providers: [provideNgxMask()],
   selector: 'app-detalhes-imovel',
   templateUrl: './detalhes-imovel.component.html',
   styleUrl: './detalhes-imovel.component.scss'
})
export class DetalhesImovelComponent implements OnDestroy {
   @ViewChild('mapaSecao') mapaSecao?: ElementRef;

   leadForm: FormGroup;
   isSubmitting = false;
   private routerSubscription!: Subscription;
   verMapa: boolean = false;
   mostrarFormulario = false;

   constructor(
      public dialog: MatDialog,
      private imovelService: ImovelService,
      private corretorService: CorretorService,
      private leadService: LeadService,
      private utilService: UtilService,
      private route: ActivatedRoute,
      @Inject(PLATFORM_ID) private platformId: Object,
      private router: Router,
      private fb: FormBuilder,
      private modalService: ModalService,
      private cdr: ChangeDetectorRef,
      private titleService: Title
   ) {
      this.leadForm = this.fb.group({
         nome: ['', Validators.required],
         telefone: ['', Validators.required], // Formato (XX) XXXXX-XXXX
         email: ['', [Validators.email]]
      });
   }

   ngOnInit(): void {
      if (isPlatformBrowser(this.platformId)) {
         this.checkMobile();
         if (typeof window !== 'undefined') {
            window.addEventListener('resize', this.checkMobile.bind(this));
         }

         // 🔹 Garante que o scroll acontece depois da renderização
         setTimeout(() => {
            window.scrollTo(0, 0);
         });

         // 🔹 Faz o scroll ao navegar entre páginas
         this.routerSubscription = this.router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
               setTimeout(() => {
                  //window.scrollTo(0, 0);
               });
            }
         });
      }

      const idImovel = this.route.snapshot.paramMap.get('id');
      if (idImovel) {
         this.buscarImovel2(idImovel);
         this.buscarImoveisSimilares(idImovel);
      }
   }

   ngOnDestroy(): void {
      this.routerSubscription?.unsubscribe();
   }

   scrollParaSecao() {
      // Aguarda o Angular renderizar o DOM
      setTimeout(() => {
         this.cdr.detectChanges(); // garante atualização do DOM

         if (this.mapaSecao) {
            this.mapaSecao.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'end' });
         }
      });
   }

   mobile: boolean = false;
   checkMobile() {
      if (typeof window !== 'undefined') {
         this.mobile = window.innerWidth < 935;
      }
   }

   private apiKey = 'AIzaSyCih4iTaq5A2XMnkCxuKFAfbJUPeOvKp28'; // 🔹 Substitua pela sua chave real
   private map!: google.maps.Map;
   private mapLoaded = false;

   imovel2: ImovelResponseDto | undefined;
   captador: CorretorResposneDto | null = null;
   groupedFotos: any[] = [];

   async clickVerMapa() {
      if (!this.verMapa) {
         this.verMapa = true;
         this.carregarScriptGoogleMaps();
         this.scrollParaSecao();
      }
   }

   async buscarImovel2(idImovel: string) {
      try {
         this.imovel2 = await this.imovelService.getImovelById(idImovel);
         this.titleService.setTitle(this.imovel2.codigo + ' - ' + this.imovel2.subtipo + ' - Cancian Imóveis');

         const { imagens, captador } = this.imovel2;
         imagens.map((img, index) => {
            img['index'] = index;
         });

         // this.carregarScriptGoogleMaps();
         this.groupedFotos = groupBy(imagens, 3);
         if (captador) {
            this.captador = await this.corretorService.getCorretorByCodigo(captador.codigo).catch((e) => null);
         }

         // if (this.mapLoaded) {
         //   this.initMap();
         // }
      } catch (e) {
         console.error(e);
      }
   }

   async abrirGaleria(index) {
      if (this.imovel2!.imagens && this.imovel2!.imagens.length > 0) {
         this.modalService.open(ImagensFullscreenComponent, {
            indexSelected: index,
            imagens: this.imovel2.imagens.map((i) => i.link),
            imagensThumb: this.imovel2.imagens.map((i) => i.link_thumb)
         });
      } else {
         alert('Nenhuma imagem disponível');
      }
   }

   carregarScriptGoogleMaps(): void {
      if (document.getElementById('google-maps-script')) {
         this.mapLoaded = true;
         this.initMap();
         return;
      }

      const script = document.createElement('script');
      script.id = 'google-maps-script';
      script.src = `https://maps.googleapis.com/maps/api/js?key=${this.apiKey}`;
      script.async = true;
      script.defer = true;
      script.onload = () => {
         this.mapLoaded = true;
         if (this.imovel2) {
            this.initMap();
         }
      };
      document.body.appendChild(script);
   }

   initMap(): void {
      const mapElement = document.getElementById('map') as HTMLElement;

      if (!mapElement) {
         console.error("Elemento 'map' não encontrado.");
         return;
      }

      if (!this.imovel2) {
         console.warn('Nenhum imóvel disponível para exibir no mapa.');
         return;
      }

      const lat = Number(this.imovel2.latitude);
      const lng = Number(this.imovel2.longitude);

      this.map = new google.maps.Map(mapElement, {
         center: { lat, lng },
         zoom: 15,
         mapTypeControl: false,
         streetViewControl: false
      });

      this.adicionarMarcador({ latitude: lat, longitude: lng });

      // Ajustar zoom para um único marcador
      setTimeout(() => {
         this.map.setZoom(15);
      }, 500);
      // this.addFullscreenControl();
   }

   addFullscreenControl() {
      const fullscreenBtnDesktop = document.getElementById('fullscreen-map-btn-desktop');
      const fullscreenBtnMobile = document.getElementById('fullscreen-map-btn-mobile');

      const toggleFullscreen = () => {
         const mapElement = document.getElementById('map') as HTMLElement;

         if (!document.fullscreenElement) {
            if (mapElement.requestFullscreen) {
               mapElement.requestFullscreen();
            }
         }
      };

      if (fullscreenBtnDesktop) {
         fullscreenBtnDesktop.addEventListener('click', toggleFullscreen);
      }
      if (fullscreenBtnMobile) {
         fullscreenBtnMobile.addEventListener('click', toggleFullscreen);
      }

      this.addExitFullscreenButtonToMap();
   }

   addExitFullscreenButtonToMap() {
      if (!this.map) return;

      const existingControls = this.map.controls[google.maps.ControlPosition.TOP_RIGHT];
      if (existingControls.getArray().some((control) => control instanceof HTMLButtonElement)) {
         return;
      }

      const exitFullscreenBtn = document.createElement('button');
      exitFullscreenBtn.innerHTML = 'Fechar Mapa ✖';
      exitFullscreenBtn.className = 'exit-fullscreen';
      exitFullscreenBtn.style.padding = '10px 15px';
      exitFullscreenBtn.style.fontSize = '16px';
      exitFullscreenBtn.style.background = 'rgba(0, 0, 0, 0.8)';
      exitFullscreenBtn.style.color = 'white';
      exitFullscreenBtn.style.border = 'none';
      exitFullscreenBtn.style.borderRadius = '5px';
      exitFullscreenBtn.style.cursor = 'pointer';

      exitFullscreenBtn.addEventListener('click', () => {
         if (document.fullscreenElement && document.exitFullscreen) {
            document.exitFullscreen();
         }
      });

      document.addEventListener('fullscreenchange', () => {
         if (document.fullscreenElement) {
            if (!existingControls.getArray().includes(exitFullscreenBtn)) {
               this.map.controls[google.maps.ControlPosition.TOP_RIGHT].push(exitFullscreenBtn);
            }
         } else {
            this.removeExitFullscreenButton(exitFullscreenBtn);
         }
      });
   }

   openWhatsApp(): void {
      if (this.captador) {
         this.enviarLeadWhatsapp(this.captador.nome);
      }

      const msg = `Olá! Gostaria de mais informações sobre o imóvel cod.: ${this.imovel2.codigo}`;
      const baseTelefone = this.captador?.telefone ?? '55999909328';

      const whatsappUrl = buildWhatsAppUrl(baseTelefone, msg);
      window.open(whatsappUrl, '_blank');
   }

   // 🔹 Abre o e-mail com o destinatário preenchido
   openEmail(): void {
      const subject = encodeURIComponent('Informações sobre o imóvel');
      const body = encodeURIComponent('Olá, gostaria de mais detalhes sobre o imóvel...');
      const mailtoUrl = `mailto:${this.captador?.email}?subject=${subject}&body=${body}`;

      window.open(mailtoUrl, '_blank');
   }

   removeExitFullscreenButton(exitFullscreenBtn: HTMLElement) {
      if (!this.map) return;

      const controls = this.map.controls[google.maps.ControlPosition.TOP_RIGHT];
      const index = controls.getArray().indexOf(exitFullscreenBtn);

      if (index > -1) {
         controls.removeAt(index);
      }
   }

   acessaCorretor(id: number): void {
      //to-do corrigir
      this.router.navigate(['/corretor/', id]);
   }

   setupFullscreenToggle() {
      const exitFullscreenBtn = document.getElementById('exit-fullscreen-btn');

      // Mostrar o botão somente quando estiver em tela cheia
      document.addEventListener('fullscreenchange', () => {
         if (document.fullscreenElement) {
            exitFullscreenBtn!.style.display = 'block';
         } else {
            exitFullscreenBtn!.style.display = 'none';
         }
      });
   }

   adicionarMarcador(local: { latitude: number; longitude: number }): void {
      if (!this.map) return;

      const tamanhoAmpliado = new google.maps.Size(47, 47);
      const tamanhoNormal = new google.maps.Size(45, 45);
      const urlIcone = '../../assets/pin-cancian.png';

      new google.maps.Marker({
         position: { lat: local.latitude, lng: local.longitude },
         map: this.map,
         icon: {
            url: urlIcone,
            scaledSize: tamanhoNormal
         }
      });
   }

   groupedImoveisSimilares: any[] = [];
   async buscarImoveisSimilares(codigo: string) {
      try {
         const similares = await this.imovelService.getImovelSemelhanteById(codigo);
         this.groupedImoveisSimilares = groupByImoveis(similares.items, 4);
      } catch (e) {
         console.log(e);
      }
   }

   adjustCarouselSize(): void {
      if (typeof document !== 'undefined') {
         const carrossel = document.querySelector('.cards') as HTMLElement;
         if (carrossel) {
            const cards = carrossel.querySelectorAll('.card-destaque');
            if (cards.length > 0) {
               const cardWidth = cards[0].getBoundingClientRect().width;
               carrossel.style.scrollSnapType = 'x mandatory';
               carrossel.style.scrollPaddingLeft = `${cardWidth * 0.1}px`; // Ajusta espaço inicial
            }
         }
      }
   }

   abreImovel(idImovel: any): void {
      this.router.navigate(['/imovel', idImovel]).then(() => {
         window.location.reload(); // Recarrega a página completamente
      });
   }

   abreApresentacao() {
      const existeVideo = this.imovel2 && this.imovel2?.videos.length > 0;
      if (existeVideo) {
         this.modalService.open(VideoImovelComponent, {
            url: this.imovel2?.videos[0].link
         });
      } else {
         alert('Vídeo indisponível');
      }
   }

   async enviarLeadWhatsapp(nomeCorretor: string) {
      try {
         const contrato = this.imovel2?.contrato;

         const params = {
            property_code: this.imovel2?.codigo + '',
            finality: contrato === 'Compra' ? 2 : 1
         };

         this.leadService.createLeadWhatsapp(params.property_code, params.finality, nomeCorretor);
      } catch (e) {
         console.log(e);
      }
   }

   async enviarLead() {
      if (this.leadForm.invalid) {
         alert('Preencha os campos obrigatórios corretamente!');
         return;
      }

      try {
         const { telefone, nome, email } = this.leadForm.value;
         const contrato = this.imovel2?.contrato;
         const codigo = this.imovel2?.codigo;

         this.isSubmitting = true;

         const utms = await this.utilService.getUtmParameters();

         const message = `  ### ${contrato} - Código: ${codigo}`;

         const leadDto: CreateLeadDto = {
            ddd: telefone.slice(0, 2),
            phone: telefone.slice(2, telefone.length),
            email,
            message,
            full_name: nome,
            property_code: this.imovel2?.codigo + '',
            subject: `${contrato}-Site: Estou interessado`,
            finality: contrato === 'Compra' ? 2 : 1,
            link: window.location.href,
            ...utms
         };

         await this.leadService.createLead(leadDto);
      } catch (e) {
         console.error(e);
      } finally {
         this.isSubmitting = false;
         this.leadForm.reset();
      }
   }

   temAreaPrivativa(imovel: ImovelResponseDto | undefined): boolean {
      return !!imovel?.area_privativa && imovel.area_privativa > 0;
   }

   temSuites(imovel: ImovelResponseDto | undefined): boolean {
      return !!imovel?.suites && imovel.suites > 0;
   }

   abreCondominio(idCondominio: number): void {
      this.router.navigate(['/condominio', idCondominio]);
   }
}